'use strict';var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||!1;descriptor.configurable=!0;if('value'in descriptor)descriptor.writable=!0;Object.defineProperty(target,descriptor.key,descriptor)}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor}}();var _desc,_value,_class;function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value}catch(error){reject(error);return}if(info.done){resolve(value)}else{return Promise.resolve(value).then(function(value){step('next',value)},function(err){step('throw',err)})}}return step('next')})}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError('Cannot call a class as a function')}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError('this hasn\'t been initialised - super() hasn\'t been called')}return call&&(typeof call=='object'||typeof call=='function')?call:self}function _inherits(subClass,superClass){if(typeof superClass!='function'&&superClass!==null){throw new TypeError('Super expression must either be null or a function, not '+typeof superClass)}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:!1,writable:!0,configurable:!0}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass}function _applyDecoratedDescriptor(target,property,decorators,descriptor,context){var desc={};Object['ke'+'ys'](descriptor).forEach(function(key){desc[key]=descriptor[key]});desc.enumerable=!!desc.enumerable;desc.configurable=!!desc.configurable;if('value'in desc||desc.initializer){desc.writable=!0}desc=decorators.slice().reverse().reduce(function(desc,decorator){return decorator(target,property,desc)||desc},desc);if(context&&desc.initializer!==void 0){desc.value=desc.initializer?desc.initializer.call(context):void 0;desc.initializer=void 0}if(desc.initializer===void 0){Object['define'+'Property'](target,property,desc);desc=null}return desc}

const _=require('pulsar-utils/dist-es6/_');
const tryGet=require('pulsar-utils/dist-es6/extensions/tryGet');
const FatigueMeterType=require('../../../../dist-es6/shared/domain/fatigueMeterType');
const BaseController=require('../../../../dist-es6/client/angularCommon/baseController');
const ControllerExtensions=require('../../../../dist-es6/client/extensions/controllerExtensions');
const{HandleUncaughtErrors:HandleUncaughtErrors}=require('../../../../dist-es6/client/services/uncaughtErrorHandler').Annotations;
const TimeInterval=require('pulsar-utils/dist-es6/timeInterval');
const moment=require('pulsar-utils/dist-es6/time/moment');

const _subViewLabelsByType={
incidents:'Incidents',
trends:'Fatigue Trends'};let


FleetInsightController=(_class=function(_BaseController){_inherits(FleetInsightController,_BaseController);_createClass(FleetInsightController,null,[{key:'$inject',get:function()
{
return[
'$timeout',
'$state',
'$scope',
'$element',
'breadcrumbsService',
'intervalService',
'fatigueTrendsDataService',
'fleetIncidentsDataService',
'uncaughtErrorHandler',
'groupTreeService',
'fatigueMeterTypeContentProviderService'];

}}]);

function FleetInsightController($timeout,$state,$scope,$element,breadcrumbsService,intervalService,fatigueTrendsDataService,fleetIncidentsDataService,uncaughtErrorHandler,groupTreeService,fatigueMeterTypeContentProviderService){_classCallCheck(this,FleetInsightController);var _this=_possibleConstructorReturn(this,
_BaseController.call(this,uncaughtErrorHandler));

_this._$timeout=$timeout;
_this._$state=$state;
_this._$scope=$scope;
_this._intervalService=intervalService;
_this._fatigueTrendsDataService=fatigueTrendsDataService;
_this._fleetIncidentsDataService=fleetIncidentsDataService;
_this._groupTreeService=groupTreeService;
_this._fatigueMeterTypeContentProviderService=fatigueMeterTypeContentProviderService;

_this._redirectPending=!1;
_this._displayInterval=void 0;
_this._currentServiceForSubView=void 0;

breadcrumbsService.startTrail(_this._fatigueMeterTypeContentProviderService.fleetInsightPageTitle);
_this.fatigueMeterType=_this._fatigueMeterTypeContentProviderService.fatigueMeterType;

_this._safeWatch('multiView',function(){
if(_this._redirectPending){
_this._redirectToFatigueTrends();
}
});
_this._safeWatch('selectedView',function(){return _this._onSelectedViewChanged()});
_this._safeWatch('displayInterval',function(){return _this._updateCurrentServiceIfStale()});return _this;
}FleetInsightController.prototype.

_onSelectedViewChanged=function _onSelectedViewChanged(){
const serviceForSubView=this.selectedView.label===_subViewLabelsByType.incidents?
this._fleetIncidentsDataService:
this._fatigueTrendsDataService;

if(_.exists(this._currentServiceForSubView)&&serviceForSubView===this._currentServiceForSubView){
return;
}

this._currentServiceForSubView=serviceForSubView;

if(!_.exists(this._displayInterval)){
const displayIntervalFromParams=_tryGetDisplayIntervalFromQueryParam(this._$state.params.interval);
this.displayInterval=displayIntervalFromParams||
this._currentServiceForSubView.displayInterval||
this._intervalService.previousFourWeeksAndWeekToDateForDisplay;
}else{
this._updateCurrentServiceIfStale();
}
};FleetInsightController.prototype.

_updateCurrentServiceIfStale=function _updateCurrentServiceIfStale(){
if(!_.exists(this._currentServiceForSubView)||
_.exists(this._currentServiceForSubView.groupTree)&&
this._displayInterval.equals(this._currentServiceForSubView.displayInterval)){
return;
}


this._currentServiceForSubView.displayInterval=this._displayInterval;
this._startUpdate();
};FleetInsightController.prototype.
























_startUpdate=function(){var ref=_asyncToGenerator(function*(){var _this2=this;
yield this._currentServiceForSubView.update();
if(this.redirectResolved){
return;
}
this._$timeout(function(){
if(_.get(_this2._fleetIncidentsDataService,'incidentTypes.length')===0){
_this2._redirectPending=!0;
if(_.exists(_this2.multiView)){
_this2._redirectToFatigueTrends();
}
}else{
_this2._fleetIncidentsDataService.redirectResolved=!0;
}
});
});function _startUpdate(){return ref.apply(this,arguments)}return _startUpdate}();FleetInsightController.prototype.

_redirectToFatigueTrends=function _redirectToFatigueTrends(){
this._redirectPending=!1;
this.multiView.selectViewAtIndex(1);
this._fleetIncidentsDataService.redirectResolved=!0;
};_createClass(FleetInsightController,[{key:'subViewLabelsByType',get:function(){return _subViewLabelsByType}},{key:'displayInterval',get:function(){return this._displayInterval},set:function(displayInterval){this._displayInterval=displayInterval;if(_.exists(displayInterval)){this._$state.go('fdc.features.fleetInsight',{interval:`${_dateForIntervalQueryParam(displayInterval.start)}to${_dateForIntervalQueryParam(displayInterval.end)}`})}}},{key:'redirectResolved',get:function(){return this._fleetIncidentsDataService.redirectResolved}},{key:'selectedGroup',get:function()

{

return this._groupTreeService.selectedGroup;
}},{key:'fatigueTrendsAggregateData',get:function()

{
if(this._currentServiceForSubView===this._fatigueTrendsDataService){
return this._fatigueTrendsDataService.selectedGroupData;
}

return null;
}},{key:'showLoadingSpinner',get:function()

{
return!_.exists(this._currentServiceForSubView)||this._currentServiceForSubView.isUpdating;
}}]);return FleetInsightController}(BaseController),(_applyDecoratedDescriptor(_class.prototype,'_startUpdate',[HandleUncaughtErrors],Object.getOwnPropertyDescriptor(_class.prototype,'_startUpdate'),_class.prototype)),_class);


function _tryGetDisplayIntervalFromQueryParam(interval){
try{
let split=interval.split('to');

let start=new Date(moment(split[0]));
let end=new Date(moment(split[1]));
if(Number.isNaN(+start)||Number.isNaN(+end)){
return null;
}
let endForDisplay=moment(end).endOf('day');
return TimeInterval.from(start).to(endForDisplay);
}catch(e){

return null;
}
}

function _dateForIntervalQueryParam(date){
return moment(date).format('YYYY-MM-DD');
}

module.exports=FleetInsightController;
//# sourceMappingURL=fleetInsightController.js.map
